module.exports = __webpack_public_path__ + "img/ahk_CLS.f56de4b3.svg";